// ** React Imports
import { Suspense, lazy } from 'react'
import ReactDOM from 'react-dom'

// ** Redux Imports
import { Provider } from 'react-redux'
import { store } from './crm-core/redux/storeConfig/store'

// ** Intl, CASL & ThemeColors Context
import ability from './crm-core/configs/acl/ability'
import { ToastContainer } from 'react-toastify'
import { AbilityContext } from './crm-core/utility/context/Can'
import { ThemeContext } from './crm-core/utility/context/ThemeColors'
import { IntlProviderWrapper } from './crm-core/utility/context/Internationalization'

// ** Spinner (Splash Screen)
import Spinner from './crm-core/@core/components/spinner/Fallback-spinner'

// ** Ripple Button
import './crm-core/@core/components/ripple-button'
import './crm-core/@fake-db'

// ** Fake Database

// ** PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import 'prismjs/components/prism-jsx.min'

// ** React Perfect Scrollbar
import 'react-perfect-scrollbar/dist/css/styles.css'

// ** React Toastify
import '@styles/react/libs/toastify/toastify.scss'

// ** React ToolTip
//import 'react-tooltip/dist/react-tooltip.css'


// ** Core styles
import './crm-core/@core/assets/fonts/feather/iconfont.css'
import './crm-core/@core/scss/core.scss'
import './crm-core/assets/scss/style.scss'

// ** Service Worker
import * as serviceWorker from './serviceWorker'

// ** Lazy load app
const LazyApp = lazy(() => import('./App'))

ReactDOM.render(
    <Provider store={store}>
        <Suspense fallback={<Spinner />}>
            <AbilityContext.Provider value={ability}>
                <ThemeContext>
                    <IntlProviderWrapper>
                        <LazyApp />
                        <ToastContainer newestOnTop />
                    </IntlProviderWrapper>
                </ThemeContext>
            </AbilityContext.Provider>
        </Suspense>
    </Provider>,
    document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
